export enum CustomField {
  POSTAL_CODE = 'postal_code',
}
